import React from "react";
import ErrorField from "./error";
import { CofinsValues } from "core/enum";
import { observer } from "mobx-react";
import { SelectField } from "components/support";

const CofinsOptions = Object.values(CofinsValues).map(p => ({
  value: p.value,
  label: p.label
}));

const CofinsField = ({ errors, row, onChange }) => {
  const { taxes } = row || {};
  const foundErrors = errors.find(v => v.name === row.name);
  const hasErrors =
    foundErrors &&
    !!foundErrors.errors &&
    !!foundErrors.errors.taxes &&
    !!foundErrors.errors.taxes.cofins;

  return (
    <div>
      {
        <SelectField
          fullWidth
          options={CofinsOptions}
          value={taxes.cofins}
          onChange={(_, value) => onChange(value)}
        />
      }
      {hasErrors && <ErrorField error={foundErrors.errors.taxes.cofins} />}
    </div>
  );
};

export default observer(CofinsField);



// WEBPACK FOOTER //
// ./src/components/app/registration/product/batch/fields/cofins.js